import { Colors, Lightning, Router, Log } from '@lightningjs/sdk'
// import VideoCover from "../components/coverItems/VideoCover";
import Loader from '../components/Loader2'
import RadioPageWrapper from '../components/RadioPageWrapper'
import TopMenu from '../components/TopMenu'
import { isFilledObject, isInteger } from '../lib/AppHelpers'
import { appSettings } from '../lib/AppSettings'

export default class Radio extends Lightning.Component {
  static _template() {
    return {
      TopMenu: { type: TopMenu },
      BG: { w: 1920, h: 1080, rect: true, color: Colors('PageBG').get() },
      Loader: { x: 1000, y: 850, type: Loader, zIndex: 100 },
      PageWrapper1: {
        type: RadioPageWrapper,
        isActiveWrapper: false,
        widgets: this.widgets,
        signals: { wrapperBuild: true },
      },
      PageWrapper2: {
        type: RadioPageWrapper,
        isActiveWrapper: false,
        widgets: this.widgets,
        signals: { wrapperBuild: true },
      },
    }
  }

  pageTransition() {
    return 'fade'
  }

  set data({ index = 0, brand, autoPlay }) {
    this._brandIndex = index
    this._brandName = brand.brandName
    this._autoPlay = autoPlay

    this.tag('TopMenu').brand = { index, brandName: brand.brandName }
    this._setState('TopMenu')
  }

  _init() {
    this._brandIndex = 0
    this._currentWrapper = 'PageWrapper2'
    this.patch({
      PageWrapper1: { widgets: this.widgets },
      PageWrapper2: { widgets: this.widgets },
    })
    this.widgets['sidemenu'].activeMenuItem = 0
    this._setState('TopMenu')
    this.tag('PageWrapper1')
      .transition('x')
      .on('finish', () => {
        this.tag('Loader').stop()
        if (this._autoPlay) {
          this._setState('Wrapper')
          this._autoPlay = false
        } else {
          this._setState('TopMenu')
        }
      })
  }
  radioMessage() {
    if (this._stationChanged) {
      this._buildPage()
      this._stationChanged = false
    }
    this.tag(this._currentWrapper).onRadioMessage()
  }
  OnGpStateChange({ playbuttonState }) {
    this.tag(this._currentWrapper).OnGpStateChange({ playbuttonState })
  }
  historyState(params) {
    if (!params) {
      return {
        brandIndex: this._brandIndex,
        radioBrand: appSettings.brands[this._brandIndex].brandName,
      }
    }
  }
  _firstActive() {
    this._appStart = true
  }
  _inactive() {
    this.widgets.globalplayer.closeWebSocket(false)
    this.stage.gc()
  }
  playbackError() {
    this.widgets.errorbox.alpha = 1
    this.widgets.errorbox.notify({ type: 'playbackStopped', Notification: true })
    Router.focusWidget('ErrorBox')
  }

  _buildPage() {
    const nowPlaying = appSettings.nowPlaying
    // const oldWrapper = this._currentWrapper;
    const data = {
      bg: appSettings.currentBrand.background,
      nowPlaying: nowPlaying,
      currShow: nowPlaying.currentShow,
      liveVideo: isFilledObject(nowPlaying.liveVideo) ? nowPlaying.liveVideo : {},
      autoPlay: this._autoPlay,
    }

    const newWrapper = this._getNewWrapper()

    data.wrapper = newWrapper
    this.tag(newWrapper.name).isActiveWrapper = true
    this.tag(this._currentWrapper).isActiveWrapper = false

    this.tag(newWrapper.name).pageData = data
    // this._currentWrapper = newWrapper.name;
  }

  wrapperBuild({ wrapper }) {
    const buildWrapper = wrapper

    this._currentWrapper = buildWrapper

    const inX = 0
    const outX = this._dir === 'right' ? -1920 : 1920
    const startX = -outX
    const inWrapper = buildWrapper
    const outWrapper = buildWrapper === 'PageWrapper1' ? 'PageWrapper2' : 'PageWrapper1'

    this.tag(inWrapper).x = startX

    this.tag(inWrapper).patch({
      smooth: {
        x: [inX, { duration: 0.4, delay: 0.2, timingFunction: 'cubic-bezier(.5,0,.5,1)' }],
      },
    })

    this.tag(outWrapper).patch({
      smooth: {
        x: [outX, { duration: 0.4, delay: 0.2, timingFunction: 'cubic-bezier(.5,0,.5,1)' }],
      },
    })

    this.tag(outWrapper).clear()

    this.stage.gc()
    this._refocus()
    // this._currentWrapper = buildWrapper;
  }

  _getNewWrapper() {
    if (this._currentWrapper === 'PageWrapper1') {
      return { name: 'PageWrapper2', nr: 2 }
    } else {
      return { name: 'PageWrapper1', nr: 1 }
    }
  }

  changeStation(radioIndex, dir) {
    this._brandIndex = radioIndex
    this._dir = dir

    appSettings.currentBrand = appSettings.brands[radioIndex]

    this._stationSelectTimeStamp = Date.now()
    this.widgets['globalplayer'].openRadio(
      appSettings.currentBrand.nationalStation.heraldId,
      this._stationSelectTimeStamp
    )

    this._stationChanged = true
    this.tag(this._currentWrapper).isActiveWrapper = false
  }

  _handleBack() {
    Log.info('Radio:HandleBack')
    Router.focusWidget('SideMenu')
  }

  static _states() {
    return [
      class Idle extends this {
        _handleDown() {
          this._setState('Wrapper')
        }
      },

      class Wrapper extends this {
        _handleUp() {
          this._setState('TopMenu')
        }

        _handleLeft() {
          Router.focusWidget('SideMenu')
        }

        _getFocused() {
          return this.tag(this._currentWrapper)
        }
      },

      class TopMenu extends this {
        $enter() {
          this.tag('TopMenu').navigating = false
        }

        _handleDown() {
          this._setState('Wrapper')
        }

        // _handleEnter() {
        // 	if (VideoPlayer.playing) {
        // 		VideoPlayer.close();
        // 	} else {
        // 		VideoPlayer.open(appSettings.currentBrand.nationalStation.streamUrl);
        // 	}
        // }

        $menuIndexChanged({ dir, index }) {
          this.mnuIdx = this.tag('TopMenu').activeMenuItem.dataIndex

          if (isInteger(index)) {
            this.tag('Loader').start()

            setTimeout(() => {
              // const page = Router.getActiveHash().split("/")[0];

              this._activeIndex = index //this.mnuIdx;

              this.tag('TopMenu').navigating = true

              this._setState('Idle')

              this.changeStation(this.mnuIdx, dir)
            }, 200)
          }
        }

        _getFocused() {
          return this.tag('TopMenu')
        }
      },

      // class VideoCover extends this {
      // 	_handleEnter() {
      // 		Router.navigate("liveVideo");
      // 	}
      //
      // 	_handleUp() {
      // 		this._setState('TopMenu');
      // 	}
      //
      // 	_handleLeft() {
      // 		this._setState("Wrapper");
      // 	}
      //
      // 	_getFocused() {
      // 		return this.tag('VideoCover');
      // 	}
      // }
    ]
  }
}
